
export const ModalFooter = ({children}) => {
    return(
        <div className="flex justify-around m-7 overflow-hidden">
         {children}
        </div>
    )
} 